// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnBox[data-v-7a9466b8] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.default[data-v-7a9466b8] {\n  display: inline-block;\n  padding: 2px 10px;\n  background-color: #1890ff;\n  color: #fff;\n  border-radius: 5px;\n  font-size: 12px;\n  margin-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
